export default __webpack_public_path__ + "static/media/youtubeClone_3.481a5765.png";